var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandleGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77012 17.2394L2.49145 16.5902L1.77012 17.2394L4.27012 20.0172C5.46184 21.3413 7.53816 21.3413 8.72988 20.0172L11.2299 17.2394C11.7257 16.6885 12 15.9737 12 15.2325V4C12 2.34315 10.6569 1 9 1H4C2.34315 1 1 2.34315 1 4V15.2325C1 15.9737 1.27433 16.6885 1.77012 17.2394Z",
    fill: "url(#paint0_linear_292_1460)",
    stroke: "#1C1F23",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_292_1460",
    x1: 2,
    y1: 2,
    x2: 2,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0E575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B9339"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandleGreen);
export default __webpack_public_path__ + "static/media/handle-green.8c6d113c332a874c1c364bd3ef2bbf46.svg";
export { ForwardRef as ReactComponent };